/** Leave missing/legacy provider colors unset so the renderer uses the theme. */
export function resolveCalendarColor(
  ...colors: (string | null | undefined)[]
): string | undefined {
  return (
    colors.find(
      color =>
        typeof color === 'string' &&
        (/^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color) ||
          (typeof CSS !== 'undefined' && CSS.supports('color', color)))
    ) ?? undefined
  );
}
